/** Long edge kept for a document photo — enough for small print on a sổ đỏ
 * or the MRZ on a CCCD, far below a phone camera's 4000px+. */
const DOC_MAX_EDGE = 2400;
const DOC_JPEG_QUALITY = 0.88;
/** Under this a photo is sent as picked. The AI reader takes at most 5MB per image. */
const SHRINK_ABOVE_BYTES = 1.5 * 1024 * 1024;

/**
 * Downscales a large document photo before upload so it stays readable by the
 * AI (5MB per image) and cheap on a farmer's mobile data. PDFs, small images
 * and anything the browser cannot decode (e.g. HEIC on desktop) go up untouched.
 */
export async function shrinkDocumentImage(file: File): Promise<Blob> {
  if (!/^image\/(jpeg|png|webp)$/.test(file.type) || file.size <= SHRINK_ABOVE_BYTES) return file;
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, DOC_MAX_EDGE / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    canvas.getContext('2d')?.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    bitmap.close();
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', DOC_JPEG_QUALITY));
    return blob && blob.size < file.size ? blob : file;
  } catch {
    return file;
  }
}
